import { useEffect, useRef } from 'react';

type UsePrevious = <T>(value: T) => T | undefined;
export const usePrevious: UsePrevious = <T>(value: T) => {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};
